<template>
  <div id="app" @click="isTimeOut">
    <el-container class="height-z100" direction="vertical">
      <el-header  v-if="header_show">
        <div class="data-header">
          <div style="width: 390px;float: left;" class="margin-l-20">
            <div style="height: 40px; padding-top: 10px;" class="text-left">
              <p style="margin-top: 2px; font-family: 庞门正道标题体;font-size: 28px">
<!--                <img src="./assets/logo.png" height="72" width="72"/>-->

                九江市电子商务大数据系统</p>
<!--              <p class="font-12">E-connerce big data system</p>-->
           </div>
          </div>
          <div style="text-align: left; padding-top: 16px;font-family: Microsoft YaHei;" v-if="userInfo != null" class="float-right font-16"> 欢迎你，{{userInfo.username}}
            /<span @click="userOut" class="margin-r-20 cursor-pointer font-14">退出登录</span>
          </div>
        </div>

      </el-header>
      <el-container class="content" style="overflow: hidden" >
        <el-aside width="230px" v-if="header_show">
          <el-menu :default-active="active_path" v-if="header_show" class="el-menu-vertical-demo" background-color="#3865A5"
                   text-color="#fff" router=""
                   active-text-color="#fff" mode="vertical"
                   style="width: 230px;min-height: 100%;text-align: left;float: left;clear: both"
                   :default-openeds="open_list">
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-place"></i>
                <span class="font-16">电商全景</span>
              </template>
              <el-menu-item index="/index">九江市全景分析</el-menu-item>
              <el-menu-item index="/JXData" v-if="userInfo.username !=='jiujiangnongye' && userInfo.password !== 'JiuJiang_2023'">江西省电商看板</el-menu-item>
              <el-menu-item index="/localArea">九江市整体分析</el-menu-item>
              <el-menu-item index="/industryAnalysis">实物类行业分析</el-menu-item>
              <el-menu-item index="/nonPhysical">非实物类行业分析</el-menu-item>
              <el-menu-item index="/goodsType">商品类型分析</el-menu-item>
              <el-menu-item index="/transactionMode">交易模式分析</el-menu-item>
              <el-menu-item index="/tradingPlatform">电商平台分析</el-menu-item>

              <el-menu-item index="/rankingList">排行榜</el-menu-item>
<!--              <i class="el-icon-folder-opened"></i>-->
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-aim"></i>
                <span class="font-16">农业电商</span>
              </template>
              <el-menu-item index="/countrysideBusiness">
                农村电商
              </el-menu-item>
              <el-menu-item index="/agricultureProducts">农产品网络零售</el-menu-item>
              <el-menu-item index="/agriculturalMeans">农资网络零售</el-menu-item>
<!--              <el-menu-item index="/threeProducts">三品一标</el-menu-item>-->
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-mobile-phone"></i>
                <span class="font-16">在线电商</span>
              </template>
              <el-menu-item index="/restaurant">
                掌上餐饮
              </el-menu-item>
              <el-menu-item index="/tour">掌上旅游</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-cherry"></i>
                <span class="font-16">特色产品</span>
              </template>
              <el-menu-item index="/ganPin">产品概览</el-menu-item>
              <el-menu-item index="/ganPinAnalysis">产品详情</el-menu-item>
<!--              <el-menu-item index="/industry">特色产业概览</el-menu-item>-->
<!--              <el-menu-item index="/industryDetail">特色产业详情</el-menu-item>-->
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">
                <i class="el-icon-goods"></i>
                <span class="font-16">特色电商</span>
              </template>
<!--              <el-menu-item index="/b2bRetailers"><i class="el-icon-coin"></i>B2B电商</el-menu-item>-->
              <el-menu-item index="/community">社区电商</el-menu-item>
<!--              <el-menu-item index="/live">直播电商</el-menu-item>-->
<!--              <el-menu-item index="/vertical">垂直电商</el-menu-item>-->
              <el-menu-item index="/selfBuildPlatform">自建平台</el-menu-item>
            </el-submenu>
            <el-submenu index="7" v-if="userInfo.username !=='jiujiangnongye' && userInfo.password !== 'JiuJiang_2023'">
              <template slot="title">
                <i class="el-icon-office-building"></i>
                <span class="font-16">电商企业库</span>
              </template>
              <el-menu-item index="/companyIndex">企业一户式查询</el-menu-item>
              <el-menu-item index="/companyFocus">重点企业分析</el-menu-item>
            </el-submenu>
          </el-menu>

        </el-aside>
        <el-main style="background: #E6E7EB;">
          <router-view v-on:public_header="public_header" :parent_value="timeChoose"  ref="mychild"
                       style="padding-bottom: 20px;padding-top:20px;min-height: 100%"/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      const item = {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄',
        clientHeight:'',
        lastTime: null, // 最后一次点击的时间
        currentTime: null, // 当前点击的时间
        timeOut: 3 * 60 * 60 * 1000 // 设置超时时间:3个小时

      };
      return {
        userInfo: {username: '', password: ''},
        header_show: false,
        active_path: '/index',
        timeChoose: '',
        tableData: Array(20).fill(item),
        open_list:['1']
      }
    },
    created () {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.oneMonth()
      this.lastTime = new Date().getTime()
      // this.isTimeOut ()
    },
    mounted () {
      this.active_path = this.$route.path
      // 获取浏览器可视区域高度
      this.clientHeight =   `${document.documentElement.clientHeight}`
      // this.$refs.homePage.$el.style.height = this.clientHeight-20+'px';
      //document.body.clientWidth;
      //console.log(self.clientHeight);
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`;
      };
      // this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {

        this.changeFixed(this.clientHeight)
      }
    },

    beforeUpdate: function () {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (this.$route.path == '/') {
        this.active_path = '/index'
      } else {
        this.active_path = this.$route.path
      }



    },
    methods: {
      isTimeOut () {
        this.currentTime = new Date().getTime() // 记录这次点击的时间
        if (this.currentTime - this.lastTime > this.timeOut) { // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
          // alert('')
          if (sessionStorage.getItem('userInfo')) { // 如果是登录状态
            this.userOut()
            this.$message('登录超时，请重新登录');
          }
          else {
            this.lastTime = new Date().getTime()
          }
        } else {
          this.lastTime = new Date().getTime() // 如果在30分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
        }
      },
      changeFixed(clientHeight){ //动态修改样式
        console.log(clientHeight);

        // this.$refs.homePage.$el.style.height = clientHeight-20+'px';
        // console.log(this.$refs.homePage.$el.style.height);
      },
      //是否显示头部
      public_header: function (bool) {
        this.header_show = bool
        this.isTimeOut ()
      },
      chooseTime(){
        console.dir(this.active_path)
        if(this.active_path == '/countrysideIndex'){
          this.$refs.mychild.getCountrysideList(this.timeChoose);
        }else if(this.active_path == '/index'){
          this.$refs.mychild.getHomeList(this.timeChoose);
        }else if(this.active_path == '/b2bRetailers'){
          this.$refs.mychild.getB2bWholeList(this.timeChoose);
        }

      },
      //选择近1个月
      oneMonth (val) {
        var dataArr = []
        var data = new Date()
        var year = data.getFullYear()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        this.timeChoose = dataArr[1]
        // console.dir(dataArr)
      },
      userOut () {
        // // this.dialogjoin = true;
        // sessionStorage.clear()
        // this.$router.push({path: '/login'})
        // // this.isLogin=true
        // localStorage.clear()
        // //加入该行后会清除缓存，当点击退出按钮后，会清除登录信息缓存
        window.location.reload();
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
    }
  }
</script>

<style>
  * {
    margin: 0;
    box-sizing: border-box;
  }

  html, body {
    height: 100%;

  }

  body {
    /*padding-bottom: 150px;*/
    /*background-color: #171C30;*/
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
    /*margin-top: 60px;*/
    height: 100%;
  }

  #app .el-menu-item.is-active {
    /*color: #FBB060 !important;/*/
    background-color:rgba(255,255,255,0.53) !important;;
  }
  .el-main{
    padding: 0 !important;
  }
  .el-menu {
    border-right: none !important;
  }
  .el-header{
    padding: 0 !important;
    height: 55px !important;
    background-color: #10366B !important;
    font-family: SimSun;
    color: white;
    font-weight: 400;
  }

  .el-submenu .el-menu-item {
    min-width: 100px;
    padding-left: 53px !important;

  }

  .el-submenu.is-active .el-submenu__title {
    /*background-color: #39C9FF !important;*/
    color: white !important;
  }

  .el-submenu.is-active .el-submenu__title i {
    color: white;
  }
  .el-submenu [class^=el-icon-]{
    color: white;
  }
  /*.data-header .el-date-editor input {*/
  /*  background-color: #2A3039 !important;*/
  /*  border: none;*/
  /*}*/

  .footer {
    height: 100px !important;
    text-align: center;
    /*width: 100%;*/
    background-color: #8B94D6;
    /*opacity: 0.9;*/
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: white;
    padding-top: 30px;
    /*margin-top: 40px;*/
    clear: both;

  }

  .el-table td, .el-table th.is-leaf {
    border-bottom: none !important;
    /*text-align: center ;*/
  }

  ::-webkit-scrollbar{
    width: 12px;

  }
  /*滚动槽*/
  ::-webkit-scrollbar-track{
    /*-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.3) ;*/
    /*border-radius: 10px;*/
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
    background: rgba(102,102,102,0.2) !important;;
    /*-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);*/
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(102,102,102,0.2) !important;;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(102,102,102,1) !important;;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue